module.exports = __webpack_public_path__ + "img/tooltip-arrow.4fbd267b.svg";